import { Font } from "@react-pdf/renderer";
import MontserratRegular from "./Montserrat-Regular.ttf";
import MontserratBold from "./Montserrat-Bold.ttf";
import MontserratLight from "./Montserrat-Light.ttf";

let registered = false;

export const registerTagFonts = () => {
  if (registered) return;
  Font.register({ family: "Montserrat-Regular", src: MontserratRegular });
  Font.register({ family: "Montserrat-Bold", src: MontserratBold });
  Font.register({ family: "Montserrat-Light", src: MontserratLight });
  registered = true;
};

registerTagFonts();
